import angular from 'angular';

export default angular.module('cms.page.find.form',[]).factory('FindFormService',
  function() {

      this.findForm = content => {
          let returnModule = {};
          content.forEach(section => {
              section.config.children.forEach(column => {
                  column.forEach(module => {
                      if (module.type === 'pageForm') {
                          returnModule = module;
                      }
                  })
              })
          });
          return returnModule;
      };

    return this;

  }).name;


// WEBPACK FOOTER //
// ./src/cmsPages/Pages/Services/FindFormService.js